import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Tags } from './shared/tags/tags-list';

@Component({
  selector: 'tf-settings-page-tags',
  imports: [CommonModule, Tags, TranslateModule],
  templateUrl: './settings-tags.component.html',
  styleUrl: './settings-tags.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagsSettings {}
